import { jsxs as t, jsx as C } from "react/jsx-runtime";
const r = ({ className: o }) => /* @__PURE__ */ t(
  "svg",
  {
    width: "40",
    height: "41",
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: o,
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M35.0013 24.0272C34.9252 22.3739 33.7956 22.3333 32.2631 22.3333C29.9025 22.3333 29.5111 22.8973 29.5111 25.1111V27.8889C29.5111 30.1027 29.9025 30.6666 32.2631 30.6666C33.7956 30.6666 34.9252 30.6261 35.0013 28.9728M17.1594 26.5C17.1594 28.8012 15.3159 30.6666 13.0418 30.6666C12.5287 30.6666 12.2721 30.6666 12.081 30.555C11.6235 30.2877 11.6692 29.7466 11.6692 29.2778V23.7222C11.6692 23.2534 11.6235 22.7123 12.081 22.445C12.2721 22.3333 12.5287 22.3333 13.0418 22.3333C15.3159 22.3333 17.1594 24.1988 17.1594 26.5ZM23.3346 30.6666C22.0406 30.6666 21.3936 30.6666 20.9915 30.2599C20.5895 29.8531 20.5895 29.1983 20.5895 27.8889V25.1111C20.5895 23.8016 20.5895 23.1469 20.9915 22.7401C21.3936 22.3333 22.0406 22.3333 23.3346 22.3333C24.6287 22.3333 25.2757 22.3333 25.6777 22.7401C26.0797 23.1469 26.0797 23.8016 26.0797 25.1111V27.8889C26.0797 29.1983 26.0797 29.8531 25.6777 30.2599C25.2757 30.6666 24.6287 30.6666 23.3346 30.6666Z",
          stroke: "#2C7FFF",
          strokeWidth: "1.5",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M25.0026 37.3333H17.8814C12.4461 37.3333 9.72838 37.3333 7.84105 36.0036C7.3003 35.6226 6.82024 35.1708 6.41544 34.6618C5.00261 32.8855 5.0026 30.3277 5.0026 25.2121V20.9697C5.0026 16.0311 5.00261 13.5617 5.78417 11.5896C7.04063 8.41902 9.69783 5.91812 13.0665 4.73557C15.162 3.99998 17.7856 3.99998 23.0329 3.99998C26.0314 3.99998 27.5306 3.99998 28.728 4.42031C30.653 5.09606 32.1714 6.52514 32.8893 8.33688C33.3359 9.46384 33.3359 10.8749 33.3359 13.6969V17.3333",
          stroke: "#2C7FFF",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M5.0013 20.6667C5.0013 17.5984 7.48861 15.1111 10.5569 15.1111C11.6665 15.1111 12.9747 15.3056 14.0536 15.0165C15.0122 14.7596 15.7609 14.0109 16.0178 13.0523C16.3068 11.9734 16.1124 10.6652 16.1124 9.55558C16.1124 6.48733 18.5997 4.00002 21.668 4.00002",
          stroke: "#2C7FFF",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  r as DocFileIcon
};
